import { NSARouterMakerResult } from "namirasoft-account-react";
import { BalanceEntities } from "../BalanceEntities";
import { BalanceLayout } from "../BalanceLayout";
import { BalanceRouterProps } from "../BalanceRouterProps";

export interface TransactionViewPageProps extends NSARouterMakerResult, BalanceRouterProps { }

function TransactionViewPage(props: TransactionViewPageProps)
{
    return (
        <BalanceLayout
            {...props}
            pages={{
                entity: BalanceEntities.transaction(props, ""),
                view: {}
            }}
        >
            <></>
        </BalanceLayout>
    );

}

export default TransactionViewPage;